import { createBrowserRouter } from 'react-router-dom';

import routesWithViews from './metaRoutesWithViews';

const router = createBrowserRouter(routesWithViews);

export default router;
